import { type TierResult, getGPUTier } from 'detect-gpu';
import { updateLoggerContext } from '@doxyme/analytics';
import { StorageKeys } from '../constants/storageKeys';
import { storage } from '@doxyme/ui/utils';

type GPUPerformance = Omit<TierResult, 'device' | 'fps'>;

let GPUTier: GPUPerformance | undefined = undefined;
let GPUTierPromise: Promise<GPUPerformance> | undefined = undefined;

export const resetGPUCache = (): void => {
  GPUTier = undefined;
  GPUTierPromise = undefined;
  storage.removeItem(StorageKeys.GPUData, true);
};

const fingerprintAndFormatGPUData = async (): Promise<GPUPerformance> => {
  const gpuTierResult = await getGPUTier();

  // Handle fallback case for Safari on OS X
  if (gpuTierResult.type === 'FALLBACK' && !(gpuTierResult.isMobile ?? false)) {
    gpuTierResult.tier = 2;
  }

  updateLoggerContext({ gpuTier: gpuTierResult.tier });
  delete gpuTierResult.device;

  return gpuTierResult;
};

const getOrCreateGPUDataPromise = async (): Promise<GPUPerformance> => {
  if (GPUTierPromise) {
    return GPUTierPromise;
  }

  GPUTierPromise = fingerprintAndFormatGPUData().then((GPUData) => {
    GPUTier = GPUData;
    GPUTierPromise = undefined;

    storage.setItem(StorageKeys.GPUData, GPUData, true);

    return GPUData;
  });

  return GPUTierPromise;
};

export const getGPUData = async (rerun = false): Promise<GPUPerformance> => {
  if (rerun) {
    return getOrCreateGPUDataPromise();
  }

  GPUTier =
    GPUTier ?? storage.getItem<GPUPerformance>(StorageKeys.GPUData, true);

  if (GPUTier) {
    updateLoggerContext({ gpuTier: GPUTier.tier });
    return GPUTier;
  }

  return getOrCreateGPUDataPromise();
};
